import { useDispatch, useSelector } from 'react-redux';

import DialogButton from 'Components/smallComponents/dialogButton.js';
import { vehicleDiscardingRequested, vehicleSelected } from 'Core/actions/fitmentSearch/index.js';
import {
  selectedVehicleSelector,
  fitmentSearchBaseFieldsSelector,
  fitmentSearchExtraFieldsSelector,
} from 'Core/selectors/fitmentSearch/index.js';
import fitmentSearchConfig from 'Models/uiConfig/fitmentSearchConfig.js';
import { cloneSafe } from 'Utils/components.ts';
import { simpleHandler } from 'Utils/roleHandler.js';

export default function SingleVehicleGarage({ template, withCurrentVehicle = true }) {
  const dispatch = useDispatch();

  const selectedVehicle = useSelector(selectedVehicleSelector);
  const baseFitmentFields = useSelector(fitmentSearchBaseFieldsSelector);
  const extraFitmentFields = useSelector(fitmentSearchExtraFieldsSelector);

  const discardVehicle = () => {
    dispatch(vehicleDiscardingRequested());
    fitmentSearchConfig.onVehicleDiscarded();
  };
  const goToResults = () => {
    dispatch(vehicleSelected(selectedVehicle));
    fitmentSearchConfig.onVehicleSelected(selectedVehicle.filteredFieldMap);
  };

  const onClick = simpleHandler({ discardVehicle, goToResults });

  const templateParams = {
    vehicle: selectedVehicle.filteredFieldMap,
    vehicleString: selectedVehicle.toString(),
    vehicleBaseValues: selectedVehicle.getFilteredValues(baseFitmentFields),
    vehicleExtraValues: selectedVehicle.getFilteredValues(extraFitmentFields),
    template: selectedVehicle.notNull ? 'locked' : 'active',
  };

  const changeButton = (templ) => {
    const props = {
      template: templ,
      templateParams,
      dialogName: 'VehicleWidgetDialog',
      metadata: { withCurrentVehicle },
    };
    return <DialogButton {...props} key="change-button" />;
  };

  const component = template.call({ changeButton, ...templateParams });
  return cloneSafe(component, null, { onClick });
}
